import { useNavigate } from 'react-router-dom';
import { Pipette, Hash, Sparkles, Layers, X } from 'lucide-react';
import { useI18n } from '../contexts/I18nContext';

export default function ToolsMenuModal({ isOpen, onClose }) {
  const navigate = useNavigate();
  const { t } = useI18n();

  if (!isOpen) return null;

  const handleToolSelect = (path) => {
    navigate(path);
    onClose();
  };

  const tools = [
    {
      path: '/picker',
      icon: <Pipette size={16} />,
      title: t('toolsMenu.picker.title'),
      description: t('toolsMenu.picker.description'),
      color: 'text-purple-500',
    },
    {
      path: '/hex-finder',
      icon: <Hash size={16} />,
      title: t('toolsMenu.hexFinder.title'),
      description: t('toolsMenu.hexFinder.description'),
      color: 'text-teal-500',
    },
    {
      path: '/collection/expand',
      icon: <Sparkles size={16} />,
      title: 'Expand Your Collection',
      description: 'Find the markers that add the most new colors.',
      color: 'text-violet-500',
    },
    {
      path: '/shades',
      icon: <Layers size={16} />,
      title: 'Shades',
      description: 'Find shades for any marker or palette.',
      color: 'text-fuchsia-500',
    },
  ];

  return (
    <>
      <div
        className="fixed inset-0 bg-black/30 backdrop-blur-sm z-50 animate-fadeOnly"
        onClick={onClose}
      />
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 pointer-events-none">
        <div className="bg-white rounded-2xl shadow-xl max-w-sm w-full pointer-events-auto animate-slideUp border border-slate-100">
          {/* Header */}
          <div className="flex items-center justify-between px-4 pt-4 pb-3 border-b border-slate-100">
            <h2 className="text-sm font-semibold text-slate-700">{t('toolsMenu.title')}</h2>
            <button
              onClick={onClose}
              className="p-1 rounded-lg hover:bg-slate-100 transition-colors"
              aria-label="Close"
            >
              <X size={16} className="text-slate-400" />
            </button>
          </div>

          {/* Tools */}
          <div className="p-2">
            {tools.map((tool, idx) => (
              <div key={tool.path}>
                {idx > 0 && (
                  <div className="mx-3 h-px" style={{ background: 'linear-gradient(to right, transparent, #e2e8f0 30%, #e2e8f0 70%, transparent)' }} />
                )}
                <button
                  onClick={() => handleToolSelect(tool.path)}
                  className="w-full flex items-center gap-3 px-3 py-3 rounded-xl hover:bg-slate-50 transition-colors text-left group"
                >
                  <span className={`shrink-0 ${tool.color}`}>{tool.icon}</span>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-slate-800">{tool.title}</p>
                    <p className="text-xs text-slate-400 truncate">{tool.description}</p>
                  </div>
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
